import React, { useContext, useEffect, useState } from "react";
import {
  EditPopover,
  NumberInput,
  Panel,
  Popover,
  PopoverAnchor,
  PopoverContent,
  RadioButtonInput,
  RangeNumberInput,
  SelectInput,
  Tabs,
  TabsV2,
  TextInput,
  ToggleInput,
  UnitInput,
} from "../input";
import { GrigoraEditorContext } from "../editor/context";
import { isEmpty } from "lodash";
import GrigoraCSSRenderer from "../blocks/css-render";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh, faTrash } from "@fortawesome/free-solid-svg-icons";
import { isUpdatedFromDefault } from "../utils";

const TRANSITIONS_MAP = {
  color: {
    label: "Text Color",
  },
  "background-color": {
    label: "Background Color",
  },
  border: {
    label: "Border",
  },
  "border-radius": {
    label: "Border Radius",
  },
  "box-shadow": {
    label: "Box Shadow",
  },
  padding: {
    label: "Padding",
  },
  margin: {
    label: "Margin",
  },
  filter: {
    label: "Filter",
  },
  "backdrop-filter": {
    label: "Backdrop Filter",
  },
  transform: {
    label: "Transform",
  },
};

function Transition({ block, actions, ...props }) {
  const {
    id,
    props: { transition = {} },
    dom,
  } = block;

  const { setProp } = actions;

  const [isAddingNew, setIsAddingNew] = useState(false);

  function removeType(type) {
    var trans = {
      ...(transition?.types ? transition?.types : {}),
    };
    delete trans[type];

    setProp((props) => {
      if (isEmpty(trans)) {
        props.transition = undefined;
      } else {
        props.transition = {
          ...(props.transition ? props.transition : {}),
          types: trans,
        };
      }
    }, 300);
  }

  function changeDuration(type, duration) {
    setProp((props) => {
      props.transition = {
        ...(props.transition ? props.transition : {}),
        types: {
          ...(props.transition?.types ? props.transition?.types : {}),
          [type]: {
            ...(props.transition?.types?.[type]
              ? props.transition?.types?.[type]
              : {}),
            duration: duration,
          },
        },
      };
    }, 300);
  }

  function changeEasing(type, easing) {
    setProp((props) => {
      props.transition = {
        ...(props.transition ? props.transition : {}),
        types: {
          ...(props.transition?.types ? props.transition?.types : {}),
          [type]: {
            ...(props.transition?.types?.[type]
              ? props.transition?.types?.[type]
              : {}),
            easing: easing,
          },
        },
      };
    }, 300);
  }

  return (
    <>
      <Panel
        isUpdated={isUpdatedFromDefault([{ key: transition, default: {} }])}
        id={`block-setting-${id}-transition`}
        title={"Transition Timings"}
        initialOpen={false}
      >
        {/* {!(transition && isEmpty(transition)) && (
          <>
            <div className="flex text-xs justify-between mb-2">
              Reset Transition Times
              <div
                onClick={() => {
                  setProp((props) => {
                    props.transition = undefined;
                  });
                }}
                className="mr-2 cursor-pointer"
              >
                <FontAwesomeIcon icon={faRefresh} size="sm" />
              </div>
            </div>
          </>
        )} */}

        {/* Transition time list */}
        {transition &&
          !isEmpty(transition) &&
          Object.keys(transition.types).map((type) => {
            return (
              <div key={`transition-${type}`} className="flex items-center">
                <EditPopover
                  label={`${TRANSITIONS_MAP[type]?.label}: ${transition.types[type].duration}s`}
                  canReset={true}
                  onReset={() => {
                    removeType(type);
                  }}
                  contentWidth={250}
                  resetPlacement={"right"}
                  resetIcon={faTrash}
                >
                  <RangeNumberInput
                    resetValue={undefined}
                    min={0}
                    max={10}
                    step={0.05}
                    value={transition?.types?.[type]?.duration}
                    onChange={(val) => {
                      changeDuration(type, val);
                    }}
                    label={"Duration (s)"}
                  />
                  <SelectInput
                    resetValue={undefined}
                    value={transition?.types?.[type]?.easing}
                    onChange={(val) => {
                      changeEasing(type, val);
                    }}
                    options={[
                      { label: "Linear", value: "" },
                      { label: "Ease", value: "ease" },
                      { label: "Ease In", value: "ease-in" },
                      { label: "Ease Out", value: "ease-out" },
                      { label: "Ease In Out", value: "ease-in-out" },
                    ]}
                    label="Easing"
                  />
                </EditPopover>
              </div>
            );
          })}

        {/* Add new transition time button */}

        <div className="flex">
          <Popover
            open={isAddingNew}
            onOpenChange={setIsAddingNew}
            placement="top"
          >
            <PopoverAnchor className="mx-auto">
              <button
                onClick={() => {
                  setIsAddingNew(true);
                }}
                className="text-xs select-none px-2 py-1 border mx-auto duration-300 rounded-[4px] border-gray-500 hover:bg-gray-100"
              >
                + Add New
              </button>
            </PopoverAnchor>
            <PopoverContent className="!bg-editor-light-main !z-[1000] !shadow-editor-floating-elements !rounded-[10px] py-2 px-2 pb-0">
              <div className="w-[300px] ">
                <SelectInput
                  resetValue={undefined}
                  value={undefined}
                  onChange={(val) => {
                    setProp((props) => {
                      props.transition = {
                        ...(props.transition ? props.transition : {}),
                        types: {
                          ...(props.transition?.types
                            ? props.transition?.types
                            : {}),
                          [val]: {
                            ...(props.transition?.types?.[val]
                              ? props.transition?.types?.[val]
                              : {}),
                            duration: 0.3,
                          },
                        },
                      };
                    }, 300);
                    setIsAddingNew(false);
                  }}
                  options={[{ label: "Select Property", value: "" }].concat(
                    Object.keys(TRANSITIONS_MAP)
                      .filter((type) => {
                        return !transition?.types?.[type];
                      })
                      .map((type) => {
                        return {
                          label: TRANSITIONS_MAP[type].label,
                          value: type,
                        };
                      }),
                  )}
                  label="Transition Type"
                />
              </div>
            </PopoverContent>
          </Popover>
        </div>
      </Panel>
    </>
  );
}

// Panel is not required.
const supportSchema = {
  id: "grigora/transition",
  name: "Transition",
  component: Transition,
};

export default supportSchema;
